import React, { useEffect, useState } from 'react';
import { fetchCrops } from '../api/cropService';
import axiosInstance from '../api/axiosInstance';
import { useTranslation } from 'react-i18next';
import { getaccesstoken } from '../context/AuthContext';

const apiPrefix = process.env.REACT_APP_API_PREFIX;

const DeleteCrop = () => {
  const { t } = useTranslation();
  const [crops, setCrops] = useState([]);
  const [selectedCrop, setSelectedCrop] = useState(null);

  useEffect(() => {
    const loadCrops = async () => {
      try {
        const cropList = await fetchCrops(true);
        setCrops(cropList);
        if (cropList.length > 0) {
          setSelectedCrop(cropList[0].name);
        }
      } catch (err) {
        console.error('Error fetching crops:', err);
      }
    };
    loadCrops();
  }, []);

  const handleDelete = async (cid) => {
    try {
      const response = await axiosInstance.delete(`${apiPrefix}/crops/${cid}`, {
        headers: {
          'auth-token': getaccesstoken(),
        }
      });
      if (response.data === 'done') {
        setCrops((prev) => prev.filter((crop) => crop.cid !== cid));
        alert(t('expert.deleteCrop.deleteSuccess'));
      }
    } catch (error) {
      console.error('Error deleting crop:', error.response?.data || error.message);
      alert(t('expert.deleteCrop.deleteError'));
    }
  };

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-2xl font-semibold text-center mb-4">{t('expert.deleteCrop.pageTitle')}</h2>
      {crops.map((crop) => (
        <div
          key={crop.cid}
          className="flex justify-between items-center bg-blue-500 text-white px-4 py-2 rounded mb-2"
        >
          <span>{crop.name}</span>
          <button
            onClick={() => handleDelete(crop.cid)}
            className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded"
          >
            {t('expert.deleteCrop.deleteButton')}
          </button>
        </div>
      ))}
      {crops.length === 0 && <p className="text-gray-500 text-center">{t('expert.deleteCrop.noCropsFound')}</p>}
    </div>
  );
};

export default DeleteCrop;